<template>
    <div class="cursor-pointer group perspective leading-tight">
        <div class="flex rounded-lg w-40 h-60 text-white relative preserve-3d group-hover:my-rotate-y-180 duration-1000"
             :style="{backgroundColor: badge.color}"
        >
            <div class="absolute backface-hidden w-full h-full p-6">
                <img :src="badge.img" class="w-28 h-28 mx-auto object-contain">
                <div class="mt-4 font-bold text-center">
                    {{ badge.name }}
                </div>
            </div>
            <div class="flex items-center justify-center text-sm font-semibold absolute rounded-lg my-rotate-y-180 backface-hidden w-full h-full overflow-hidden p-6"
                 :style="{backgroundColor: badge.color}"
            >
                <div>{{ badge.description }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default  {
    props: ['badge'],
}
</script>